import { NgModule } from '@angular/core';
import { Ng2Select2BootstrapComponent } from './ng2-select2-bootstrap.component';

@NgModule({
  imports: [
  ],
  declarations: [Ng2Select2BootstrapComponent],
  exports: [Ng2Select2BootstrapComponent]
})
export class Ng2Select2BootstrapModule { }
